import { Component } from '@angular/core';
import { AuthService } from '../../auth/services/auth.service';


@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})

export class AppFooterComponent {

    constructor(private authService: AuthService) {

    }

    public get isLoggedIn() {
        return this.authService.isLoggedIn;
    }
}





// WEBPACK FOOTER //
// ./src/app/footer/components/footer.component.ts